export default class TableData {
    constructor(
        header: Array<string>,
        /** perus tekstidata ilman lisäominaisuuksia */
        data: Array<Array<string>> | null = null,
        /** laajennettu data: string = rivin  arvot, boolean = onko rivi korostettu */
        extendedData: Map<string[], boolean> | null = null) {
            this.header = header
            this.data = data
            this.extendedData = extendedData
        }

    header!: Array<string>
    data?: Array<Array<string>> | null
    extendedData?: Map<string[], boolean> | null

    toJsonObject(): any {
        return {
            header: this.header,
            data: this.data,
            extendedData: this.extendedData
        }
    }

    static empty(): any {
        return new TableData([], [], null)
    }
}
